import { Link } from '@opendoor/bricks/core';

/* storybook-check-ignore */
export const AccessibilityText = () => (
  <>
    Opendoor Labs Inc. is dedicated to improving the accessibility of its Website and we view
    accessibility as a continually ongoing effort. Please contact us at{' '}
    <Link
      fontWeight="semibold"
      href="mailto:support@opendoor.com"
      aria-label=""
      analyticsName="cosmos-contact-opendoor-email"
    >
      support@opendoor.com
    </Link>{' '}
    with any support needs, feedback or suggestions.
  </>
);
